import React, { useState } from 'react';
import BrandGuideEditor from './BrandGuideEditor';

function ClientForm({ client, onSubmit, onCancel, saving }) {
  const [form, setForm] = useState({
    name: client?.name || '',
    segment: client?.segment || '',
    positioning: client?.positioning || '',
    channels: client?.channels?.join(', ') || '',
    cadence: client?.cadence || '',
    brandGuide: client?.brandGuide || '',
  });

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      name: form.name.trim(),
      segment: form.segment.trim(),
      positioning: form.positioning.trim(),
      channels: form.channels.split(',').map(c => c.trim()).filter(Boolean),
      cadence: form.cadence.trim(),
      brandGuide: form.brandGuide,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="form-label">Nome *</label>
        <input
          className="form-input"
          value={form.name}
          onChange={(e) => handleChange('name', e.target.value)}
          placeholder="Nome do cliente"
          required
        />
      </div>
      <div className="form-group">
        <label className="form-label">Segmento</label>
        <input
          className="form-input"
          value={form.segment}
          onChange={(e) => handleChange('segment', e.target.value)}
          placeholder="Ex: Assessoria de Investimentos"
        />
      </div>
      <div className="form-group">
        <label className="form-label">Posicionamento</label>
        <input
          className="form-input"
          value={form.positioning}
          onChange={(e) => handleChange('positioning', e.target.value)}
          placeholder="Frase de posicionamento do cliente"
        />
      </div>
      <div className="form-group">
        <label className="form-label">Canais (separados por virgula)</label>
        <input
          className="form-input"
          value={form.channels}
          onChange={(e) => handleChange('channels', e.target.value)}
          placeholder="Instagram, LinkedIn, YouTube"
        />
      </div>
      <div className="form-group">
        <label className="form-label">Cadencia / Fase</label>
        <input
          className="form-input"
          value={form.cadence}
          onChange={(e) => handleChange('cadence', e.target.value)}
          placeholder="Ex: Fase 2 — Construcao de Autoridade"
        />
      </div>
      <BrandGuideEditor
        value={form.brandGuide}
        onChange={(val) => handleChange('brandGuide', val)}
      />
      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={saving}>
          Cancelar
        </button>
        <button type="submit" className="btn btn-primary" disabled={saving || !form.name.trim()}>
          {saving ? 'Salvando...' : client ? 'Salvar' : 'Criar Cliente'}
        </button>
      </div>
    </form>
  );
}

export default ClientForm;
